import React, {useState} from "react";
import "./ManagementHistoryCard.scss";
import Rodal from "rodal"
import 'rodal/lib/rodal.css';
import moment from "moment-jalaali";
import {courierManagerOrderDetail} from "../SendManagementService";
import Expand from "react-expand-animated";
import {convertStatusCode} from "../../../Services";

const verify = {
    "rewards": [],
    "payment_transaction": {
        "invoice_uid": "",
        "gateway": {
            "title": "",
            "image": ""
        },
        "amount": null,
        "reference_number": "",
        "is_successful": false,
        "is_verified": false
    },
    "invoice": {
        "id": 5566,
        "uid": "THTq5oH8c6",
        "user": {
            "uid": "kmVrnxT4fL",
            "phone": "09363565238",
            "first_name": "رضا",
            "last_name": "مزارلو",
            "image": null,
            "email": "",
            "gender": "male",
            "birthday_date": null
        },
        "merchant": {
            "uid": "ZDegRfpazn",
            "name": "کافه شمرون - پارک گفتگو",
            "subtitle": null,
            "mall_uid": "XWMZPkGyte",
            "mall_name": "کافه شمرون",
            "payment_sdk_client_id": null,
            "description": "تراس کافه‌شمرون بوستان گفتگو با سقفی که آسمونه، کنار دریاچه با منظره پر از درخت \r\n\r\nاگر دلتون یه دورهمی تو فضای باز رو می‌خواد،\r\n یا که دوست دارید جایی کنار آب و ماهی‌های گلی، وسط یه حیاط پر درخت وقت بگذرونید\r\nتو کافه شمرون بوستان گفتگو منتظرتون هستیم.",
            "image": "https://s3.mobank.co/loyalty-media/merchant/merchant/images/large_pic_ZkckqG7_A8w4hDR.png",
            "floor_uid": null,
            "unit": null,
            "thumbnail": "https://s3.mobank.co/loyalty-media/merchant/merchant/images/logo-goftogoo-1_xdE76sp.png",
            "cover": "https://s3.mobank.co/loyalty-media/merchant/merchant/images/cover_dwOPQ03-min_Cngwue4.jpg",
            "order": 4,
            "is_featured": true,
            "categories": [
                {
                    "uid": "d7C7afsPf7",
                    "title": "کافه"
                },
                {
                    "uid": "fBRSjyMboF",
                    "title": "رستوران"
                }
            ],
            "map_image": null,
            "marker": "https://s3.mobank.co/loyalty-media/merchant/marker/icon/Gv3u8GgFS7.png",
            "phone": "02188230930",
            "hours": "9 تا 24",
            "address": "تهران، گیشا، انتهای خیابان پیروزی شرقی، ضلع شمالی بوستان گفتگو، مجموعه پذیرایی گفتگو",
            "website": "http://cafeshemroon.com",
            "wallet_id": null,
            "tags": [],
            "created": "2020-10-07T16:10:26.241001+03:30",
            "type": "merchant",
            "acceptor": "304f6221015947b4991a28ea74c40977",
            "geometry": {
                "type": "Point",
                "coordinates": [
                    51.3819623,
                    35.7375291,
                    0,
                    null
                ]
            },
            "online_merchant": false
        },
        "order": {
            "uid": "JCYv53b8Xb",
            "status": 3,
            "status_label": "finalize_by_user",
            "amount": 10000.0,
            "original_amount": 10000,
            "discount": 0,
            "description": null,
            "items": [
                {
                    "uid": "AqcwkyHDNA",
                    "name": "نان و پنیر و گردو",
                    "quantity": 1,
                    "per_amount": 10000,
                    "amount": 10000,
                    "product_id": 110738,
                    "product": {
                        "uid": "MA6KZ9Fazf",
                        "name": "نان و پنیر و گردو",
                        "price_original": 10000,
                        "price": 10000,
                        "stock": 10,
                        "is_available": true,
                        "image": "https://s3.mobank.co/loyalty-media/product/product/images/gerdoo.jpg"
                    },
                    "per_discount": 0,
                    "discount": 0,
                    "original_amount": 10000,
                    "is_canceled": false,
                    "pay_status": 2,
                    "picked_quantity": 0
                }
            ]
        },
        "coupon": null,
        "amount": 10000,
        "discount_amount": 0,
        "payable_amount": 10000,
        "state": "success_to_pay",
        "paid_at": "2020-12-28T12:02:05.466204+03:30",
        "purchase_token": "10425966f414b888a94a536cb01b4c875299",
        "description": null,
        "calculation_log": [],
        "created": "2020-12-28 10:10:58.923853+00:00"
    }
}

function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }
    return "-"
}


function ManagementHistoryCard({item}) {

    const [showModal,set_showModal] = useState(false)
    const [detail,set_detail] = useState([])
    const [showDetailModal,set_showDetailModal] = useState(false)
    const [attribExpand ,set_attribExpand] = useState(false);
    const [cardModal ,set_cardModal] = useState(false);

    const convertStack = (stack) =>{
        switch (stack) {
            case 'accepted':
                return "قبول"
                break;
            case 'noAccepted':
                return "ادامه"
                break;
        }
    }


    const ConvertTMonthName = (month) =>{
        let name= "";
        switch (month) {
            case '01':
                name =  "فروردین";
                break;
            case '02':
                name =  "اردیبهشت";
                break;
            case '03':
                name =  "خرداد";
                break;
            case '04':
                name =  "تیر";
                break;
            case '05':
                name =  "مرداد";
                break;
            case '06':
                name =  "شهریور";
                break;
            case '07':
                name =  "مهر";
                break;
            case '08':
                name =  "آبان";
                break;
            case '09':
                name =  "آذر";
                break;
            case '10':
                name =  "دی";
                break;
            case '11':
                name =  "بهمن";
                break;
            case '12':
                name =  "اسفند";
                break;
            default:
                name =  "---";
        }

        return name;
    }


    const ConvertToJalaliSplited = (date) =>{
        if(date){
            let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
            let year = moment.utc(date.split('+')[0]).format('jYYYY');
            let day = moment.utc(date.split('+')[0]).format('jDD');
            let hh = moment.utc(date.split('+')[0]).format('HH');
            let mm = moment.utc(date.split('+')[0]).format('mm');
            return {month,year,day,hh,mm}
        }
    }

    const ConvertToJalaliSplitedString = (date) =>{
        if(date){
            let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
            let year = moment.utc(date.split('+')[0]).format('jYYYY');
            let day = moment.utc(date.split('+')[0]).format('jDD');
            let hh = moment.utc(date.split('+')[0]).format('HH');
            let mm = moment.utc(date.split('+')[0]).format('mm');
            return day+" "+month+""+year+" - "+hh+":"+mm
        }
    }


    const showDetail = async (id) =>{
        set_cardModal(true)
        try{
            const response = await courierManagerOrderDetail(id);
            set_cardModal(false)
            console.log(response.data)
            set_detail(response.data)
            set_showDetailModal(true);
        }catch (e) {
            set_cardModal(false)
        }

    }

    return(
        <>
            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'350px'}}
                animation={"zoom"}
                showCloseButton={false}
                visible={showDetailModal} onClose={()=>set_showDetailModal(false)}>
                <div className="history-card-modal">

                    <div className="status-row">
                        <span>{convertStatusCode(detail.status)}</span>
                    </div>

                    <div className="head-row">
                        <div className="factor-num">
                            <div className="factor-label">
                                {detail.uid}
                            </div>
                        </div>
                        <div className="user-sec">
                            {detail && detail.user?<span className="user-label">{detail.user.first_name+" "+detail.user.last_name}</span>:"_"}
                            <img src="/other/g-user.png" alt=""/>
                        </div>
                    </div>

                    <div className="head-row-driver">
                        <div className="factor-num">

                        </div>
                        <div className="driver-sec">
                            {detail && detail.courier ? <span className="user-label" style={{marginTop:15}}>{detail.courier.first_name+" "+detail.courier.last_name}</span>:"-"}
                            <img src="/svg/motor-scooter.svg" alt=""/>
                        </div>
                    </div>

                    <div className="factor-sec">
                        <div className="factor-item">
                            <span className="factor-item-val amount" > {numberWithCommas(detail.amount)} تومان </span>
                            <span className="factor-item-label amount-label">مبلغ فاکتور  </span>
                        </div>
                        <div className="factor-item">
                            <span className="factor-item-val">{ConvertToJalaliSplitedString(detail.accept_courier_at)}</span>
                            <span className="factor-item-label">زمان تحویل پیک</span>
                        </div>
                        <div className="factor-item">
                            <span className="factor-item-val g-theme">{ConvertToJalaliSplitedString(detail.delivery_due)}</span>
                            <span className="factor-item-label">زمان سررسید تحویل</span>
                        </div>

                        <div className="address-item">
                            <span>آدرس : </span>
                            <p>{detail && detail.address?detail.address.address:" _ "}</p>
                        </div>

                    </div>

                    <div className="factor-subItems-collapse" onClick={()=>{
                        set_attribExpand(!attribExpand)
                    }}>
                        <span>ریز اقلام</span>
                        <i className="fa fa-angle-down"></i>
                    </div>
                    <div className="factor-sub-items">
                        <Expand open={attribExpand}>
                            <div className="factor-table" style={{paddingBottom:120}}>
                                <table>
                                    <thead>
                                    <tr>
                                        <th className="product-table-head">جمع کل</th>
                                        {/*<th className="product-table-head">تخفیف</th>*/}
                                        <th className="product-table-head">تعداد</th>
                                        <th className="product-table-head product-table-head-name">نام کالا</th>
                                        <th className="product-table-head product-table-head-name">تصویر</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {detail && detail.items  && detail.items.map(product => {
                                        return (
                                            <tr key={product.uid}>
                                                <td className="product-price">{numberWithCommas(product.amount)}</td>
                                                {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                                <td className="product-count">{product.quantity}</td>
                                                <td className="product-name">{product.name}</td>
                                                <td className="product-name">
                                                    {product.product?<img src={product.product && product.product.image ? product.product.image : "/other/skeleton/product.jpg"} alt=""/>:null}
                                                </td>
                                            </tr>
                                        )
                                    })
                                    }
                                    </tbody>
                                </table>

                                <div className="factor-table-total-row customer_discount-row">
                                    <div className="factor-table-total--price customer_discount-val">
                                        <span>تومان</span>
                                        {<span>{numberWithCommas(verify.invoice.discount_amount)}</span>}
                                    </div>
                                    <span className="customer_discount"> : تخفیف  </span>
                                </div>

                                <div className="factor-table-total-row">
                                    <div className="factor-table-total--price">
                                        <span>تومان</span>
                                        {detail.amount ? <span>{numberWithCommas(detail.amount)}</span> : null}
                                    </div>
                                    <span> : جمع کل  </span>
                                </div>
                            </div>
                        </Expand>
                    </div>
                </div>
            </Rodal>
        <div className="history-card-container" onClick={()=>{
            console.log(":SSSs")
            showDetail(item.uid)
        }}>

            <div className="date-arrow" onClick={()=>{
                //showDetail(item.uid)
            }}>
                <div className="date" style={{display:"flex"}}>
                    <span className="fa fa-arrow-left"></span>
                    <span>{ConvertToJalaliSplited(item.from_shipping_time).year}</span>
                    <span>{ConvertToJalaliSplited(item.from_shipping_time).month}</span>
                    <span>{ConvertToJalaliSplited(item.from_shipping_time).day}</span>
                    <span>{" - "+ConvertToJalaliSplited(item.from_shipping_time).hh+":"+ConvertToJalaliSplited(item.from_shipping_time).mm}</span>
                </div>
            </div>
            <div className="right-sec" onClick={()=>{
                //showDetail(item.uid)
            }}>
                <div className="current-card-info">
                    <span className="name">{item.uid}</span>
                    <span className="status">{convertStatusCode(item.status)}</span>
                </div>
                {!cardModal?
                    <img src="/other/basket_icon.png" alt=""/>
                    :<i className="fa fa-spinner fa-spin"></i>
                }
            </div>
        </div>
            </>
    )

}

export {ManagementHistoryCard}
